import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — eneatipo 4. Portado de
 * `docs/canonical/Plantilla_maestra_nueve_eneatipos.docx`, Bloques A, B, D y E.
 *
 * En inglés, con el original español al lado de cada campo, igual que los
 * patrones 1, 6 y 9.
 *
 * Las marcas del canon se conservan: [PROPUESTA] es formulación del proyecto,
 * [LÍMITE] es un riesgo declarado, [FUENTE PROYECTO] viene de Vilaseca. Que
 * `shortHypothesis` sea [PROPUESTA] y no fuente externa importa: es la frase
 * que la persona lee como resultado.
 *
 */
export const PATTERN_4: Pattern = {
  id: "4",
  number: 4,
  // «el especial» — Vilaseca: «el especial»
  workingName: "The singular one (working name)",
  // Patrón organizado alrededor de la carencia y la particularidad como forma de ser alguien
  shortHypothesis:
    "A pattern organised around what is missing and what makes you different, " +
    "as the way to be someone rather than no one.",
  // Comparación frecuente que termina en sensación de carencia; intensidad como forma de hacer real la experiencia
  whatItExplains:
    "Frequent comparison that ends in a sense of lack, and intensity as a way " +
    "of making experience feel real.",
  // Qué considera cada persona «lo corriente»; por qué alguien concreto prioriza la autenticidad sobre otros valores
  whatItDoesNotExplain:
    "What any given person finds ordinary, or why one person places " +
    "authenticity above other values.",
  // [LÍMITE] Definirse como «la distinta de siempre» y usar la etiqueta para mantener lo cotidiano a distancia
  identityRisk:
    "Defining yourself as \u201cthe different one\u201d and using the label to keep " +
    "ordinary life at a distance.",
  confusablePatterns: ["3", "5"],
  sourceRefs: [
    "Plantilla_maestra_nueve_eneatipos.docx, Eneatipo 4, Bloques A, B, D y E",
    "[LÍMITE] Vilaseca-céntrico: sin triangular contra una segunda fuente"
  ],
  contentVersion: "canon-nueve-1.0"
};
